import React from "react";

import { Container, Message } from ".";
import { COLOR } from "./theme";

export const TestMode = ({color}) => (
  <Container padding="6 0 0 0" maxWidth="1110">
    <Message severity="warning-or-significant" bg={COLOR.MID_BLUE_100} color={color}>
      This shop is currently running in test mode. All transactions are
      simulated and no payments will be processed.
    </Message>
  </Container>
);
